// extracted by mini-css-extract-plugin
export var actions = "CookieBanner-module--actions--d64f8";
export var always = "CookieBanner-module--always--b76e5";
export var body = "CookieBanner-module--body--76ed6";
export var categories = "CookieBanner-module--categories--4417a";
export var category = "CookieBanner-module--category--6daf4";
export var categoryDesc = "CookieBanner-module--categoryDesc--5e757";
export var categoryHead = "CookieBanner-module--categoryHead--1bd89";
export var categoryName = "CookieBanner-module--categoryName--892a4";
export var inlineLink = "CookieBanner-module--inlineLink--b7e11";
export var overlay = "CookieBanner-module--overlay--d03ad";
export var panel = "CookieBanner-module--panel--961de";
export var primary = "CookieBanner-module--primary--80b85";
export var secondary = "CookieBanner-module--secondary--9f54a";
export var slider = "CookieBanner-module--slider--fb2cf";
export var text = "CookieBanner-module--text--da20d";
export var title = "CookieBanner-module--title--03096";
export var toggle = "CookieBanner-module--toggle--e258a";